var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2949 8.82925H11.2949M16.2949 12.6969H11.2949M16.2949 4.96162H11.2949M7.79492 1.09399L7.79492 18.4983M6.59492 1.09399H14.9949C16.6751 1.09399 17.5152 1.09399 18.1569 1.41015C18.7214 1.68826 19.1803 2.13201 19.4679 2.67781C19.7949 3.29831 19.7949 4.11059 19.7949 5.73515V13.8572C19.7949 15.4817 19.7949 16.294 19.4679 16.9145C19.1803 17.4603 18.7214 17.904 18.1569 18.1822C17.5152 18.4983 16.6751 18.4983 14.9949 18.4983H6.59492C4.91476 18.4983 4.07469 18.4983 3.43295 18.1822C2.86846 17.904 2.40952 17.4603 2.1219 16.9145C1.79492 16.294 1.79492 15.4817 1.79492 13.8572V5.73514C1.79492 4.11059 1.79492 3.29831 2.1219 2.67781C2.40952 2.13201 2.86846 1.68826 3.43295 1.41015C4.07469 1.09399 4.91476 1.09399 6.59492 1.09399Z",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuProgram);
export default __webpack_public_path__ + "static/media/menu_program.637270185e7b8a54b97aba769e56494c.svg";
export { ForwardRef as ReactComponent };